// v2/constants/nav.js — header navigasyonu
// NOT: henuz sayfalari yok. Sayfa acildikca { to: '/v2/orders' } eklenir,
// Header otomatik Link'e cevirir.

export const HEADER_NAV = [
  { id: 'ai',       label: 'Yapay Zekâya Sor', icon: 'Sparkles',   to: null, accent: true },
  { id: 'account',  label: 'Hesabım',          icon: 'User',       to: null },
  { id: 'orders',   label: 'Siparişlerim',     icon: 'ClipboardList', to: null },
  { id: 'debt', label: 'Borç Yaşlandırma',      icon: 'Wallet',   to: null },
  { id: 'payment',  label: 'Ödeme Yap',        icon: 'CreditCard', to: null,
    href: 'https://www.bosch-tahsilat.com/' },
];

export const USER_MENU = [
  { id: 'account',  label: 'Hesabım',       icon: 'User' },
  { id: 'orders',   label: 'Siparişlerim',  icon: 'Package' },
  { id: 'quotes',   label: 'Teklif Al',     icon: 'FileText' },
  { id: 'debt', label: 'Borç Yaşlandırma',   icon: 'Wallet' },
  { id: 'balance',  label: 'Bakiye & Borç', icon: 'Wallet' },
  { id: 'cart',     label: 'Sepetim',       icon: 'ShoppingCart' },
  { id: 'logout',   label: 'Çıkış Yap',     icon: 'LogOut', danger: true },
];

// Mobil alt cubuk — 4 sik kullanilan
export const BOTTOM_NAV = [
  { id: 'home',     label: 'Ana Sayfa', icon: 'Home',         to: '/v2' },
  { id: 'products', label: 'Ürünler',   icon: 'Boxes',        to: '/v2/products' },
  { id: 'cart',     label: 'Sepetim',   icon: 'ShoppingCart', to: '/v2/cart', badge: 'cart' },
  { id: 'menu',     label: 'Menü',      icon: 'Menu',         to: null, action: 'drawer' },
];

// Hamburger paneli — tam liste
export const DRAWER_MENU = [
  { id: 'ai',       label: 'Yapay Zekâya Sor', icon: 'Sparkles', accent: true },
  { id: 'account',  label: 'Hesabım',          icon: 'User' },
  { id: 'orders',   label: 'Siparişlerim',     icon: 'ClipboardList' },
  { id: 'quotes',   label: 'Teklif Al',        icon: 'FileText' },
  { id: 'payment',  label: 'Ödeme Yap',        icon: 'CreditCard',
    href: 'https://www.bosch-tahsilat.com/' },
  { id: 'debt', label: 'Borç Yaşlandırma',      icon: 'Wallet' },
  { id: 'balance',  label: 'Bakiye & Borç',    icon: 'Wallet' },
  { id: 'logout',   label: 'Çıkış Yap',        icon: 'LogOut', danger: true },
];
